import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
} from "chart.js";
import { AirSpaceGraph } from "../../../services/iotServices";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const HotColdVoteLineChart = ({
  graphData,
}: {
  graphData: AirSpaceGraph[];
}) => {
  const redColor = "rgb(255, 99, 132)";
  const blueColor = "rgb(53, 162, 235)";
  const tempUnit = "℃";
  const humUnit = "%";

  const { labels, tempList, humList } = {
    labels: graphData.map((item) => item.time),
    tempList: graphData.map((item) => Number(item.temperature)),
    humList: graphData.map((item) => Number(item.humidity)),
  };

  const options: ChartOptions<"line"> = {
    scales: {
      leftY: {
        ticks: {
          color: redColor,
          font: {
            weight: "bold",
          },
          callback: (value) => {
            return Number(value).toFixed(1) + tempUnit;
          },
        },
        type: "linear",
        grid: {
          display: true,
        },
      },
      rightY: {
        ticks: {
          color: blueColor,
          font: {
            weight: "bold",
          },
          callback: (value) => {
            return Number(value).toFixed(1) + humUnit;
          },
        },
        type: "linear",
        grid: {
          display: false,
        },
        position: "right",
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
        // 범례 디자인
        labels: {
          boxWidth: 20,
          boxHeight: 1,
        },
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: "온도",
        data: tempList,
        borderColor: redColor,
        backgroundColor: redColor,
        yAxisID: "leftY",
      },
      {
        label: "습도",
        data: humList,
        borderColor: blueColor,
        backgroundColor: blueColor,
        yAxisID: "rightY",
      },
    ],
  };

  return (
    <Line
      className="w-48 h-48"
      datasetIdKey="id"
      data={data}
      options={options}
    />
  );
};
